<p-confirmDialog key="batchnotify" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Search Options-->
<div class="ItemBorder">
	<h4 style="text-align: center">Search Options</h4>

	<div class="MainGrid2Col">
		<label>Person Type:</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="PersonTypeID" [(ngModel)]="PersonTypeID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstPersonType" [ngValue]="o.ID">{{ o.Desc }}</option>
		</select>

		<label>School:</label>
		<caass-schoolselector [ShowAll]="true" [ShowAllText]="SchoolSelectShowAllText" [Disabled]="IsLoading() == true"> </caass-schoolselector>

		<label *ngIf="PersonTypeID == 1">Grade Level:</label>
		<select *ngIf="PersonTypeID == 1" [disabled]="IsLoading() == true" class="form-control" name="GradeLevelID" [(ngModel)]="GradeLevelID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstGradeLevel" [ngValue]="o.GradeLevelID">{{ o.GradeLevelDesc }}</option>
		</select>

		<label *ngIf="PersonTypeID == 1">Academy:</label>
		<select *ngIf="PersonTypeID == 1" [disabled]="IsLoading() == true" class="form-control" name="AcademyID" [(ngModel)]="AcademyID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstAcademy" [ngValue]="o.AcademyId">{{ o.AcademyDesc }}</option>
		</select>

		<label *ngIf="PersonTypeID == 1">Homeroom:</label>
		<select *ngIf="PersonTypeID == 1" [disabled]="IsLoading() == true" class="form-control" name="HomeroomID" [(ngModel)]="HomeroomID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstHomeroom" [ngValue]="o.HomeroomId">{{ o.HomeRoom }}</option>
		</select>

		<label *ngIf="PersonTypeID == 1">Group:</label>
		<select *ngIf="PersonTypeID == 1" [disabled]="IsLoading() == true" class="form-control" name="GroupID" [(ngModel)]="GroupID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstGroup" [ngValue]="o.GroupID">{{ o.GroupName }}</option>
		</select>

		<label>Filter:</label>
		<input type="text" class="form-control" style="min-width: 300px" [(ngModel)]="Criteria" placeholder="Search by Name, Student ID, or Staff ID" />
	</div>

	<div class="Buttons">
		<button class="btn btn-primary" (click)="onSearch()">Search</button>
	</div>
</div>

<!--Results Table-->
<div class="ItemBorder TopMargin">
	<h4 style="text-align: center">Select Portal App Users</h4>

	<div>
		<p-table
			#mydt
			[value]="lstTable"
			[loading]="LoadingTable"
			[paginator]="true"
			[(rows)]="pagerows"
			[(first)]="pagefirst"
			[showCurrentPageReport]="true"
			[resizableColumns]="false"
			sortMode="multiple"
			styleClass="p-datatable-striped"
			selectionMode="multiple"
			[(selection)]="SelectedRegUsers"
			dataKey="PersonID"
			(onRowSelect)="onRowSelect($event)"
			(onRowUnselect)="onRowUnselect($event)"
			currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
			[rowsPerPageOptions]="[5, 10, 25, 50]"
		>
			<!--Headers-->
			<ng-template pTemplate="header">
				<!--Filter or Select from Dropdown-->
				<tr>
					<th></th>
					<!--ID-->
					<th>
						<p-columnFilter type="text" field="ID" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--FirstName-->
					<th>
						<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--LastName-->
					<th>
						<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--AppTypeDesc-->
					<th>
						<p-columnFilter field="AppTypeDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterAppTypeDesc
									[ngModel]="value"
									[options]="lstAppTypeDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--SchoolName-->
					<th>
						<p-columnFilter field="SchoolName" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterSchoolName
									[ngModel]="value"
									[options]="lstSchoolName"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--UserID_Email-->
					<th>
						<p-columnFilter type="text" field="UserID_Email" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--UserFirstName-->
					<th>
						<p-columnFilter type="text" field="UserFirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--UserLastName-->
					<th>
						<p-columnFilter type="text" field="UserLastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>
				</tr>

				<!--Column Names-->
				<tr style="height: 4rem">
					<th>
						<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
					</th>

					<th pSortableColumn="ID">ID<p-sortIcon field="ID"></p-sortIcon></th>
					<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
					<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
					<th pSortableColumn="AppTypeDesc">App<p-sortIcon field="AppTypeDesc"></p-sortIcon></th>
					<th pSortableColumn="SchoolName">School<p-sortIcon field="SchoolName"></p-sortIcon></th>
					<th pSortableColumn="UserID_Email">User<p-sortIcon field="UserID_Email"></p-sortIcon></th>
					<th pSortableColumn="UserFirstName">User First Name<p-sortIcon field="UserFirstName"></p-sortIcon></th>
					<th pSortableColumn="UserLastName">User Last Name<p-sortIcon field="UserLastName"></p-sortIcon></th>
				</tr>
			</ng-template>

			<!--Data-->
			<ng-template pTemplate="body" let-RegUser>
				<tr [pSelectableRow]="RegUser">
					<td>
						<p-tableCheckbox [disabled]="IsLoading() == true" [pSelectableRow]="RegUser" [value]="RegUser"></p-tableCheckbox>
					</td>

					<td *ngFor="let col of cols" style="font-weight: bold">
						{{ RegUser[col.field] }}
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</div>

<!--Buttons-->
<div class="ItemBorder TopMargin">
	<h4 style="text-align: center">Notification Options</h4>

	<div class="MainGrid2Col" style="grid-template-columns: auto auto auto">
		<label>Send to Parent Portal App:</label>
		<input type="checkbox" class="CHK" [(ngModel)]="SendToParent" />
		<label>({{ GetParentCount() | number : "1.0" : "en-US" }} Users Selected)</label>

		<label>Send to Student Portal App:</label>
		<input type="checkbox" class="CHK" [(ngModel)]="SendToStudent" />
		<label>({{ GetStudentCount() | number : "1.0" : "en-US" }} Users Selected)</label>

		<label>Send to Staff Portal App:</label>
		<input type="checkbox" class="CHK" [(ngModel)]="SendToStaff" />
		<label>({{ GetStaffCount() | number : "1.0" : "en-US" }} Users Selected)</label>
	</div>

	<div class="FlexDiv TopMargin">
		<label style="margin-right: 10px">Message:</label>
		<input class="form-control" [(ngModel)]="Message" />
	</div>

	<div class="Buttons">
		<button class="btn btn-primary" (click)="onSend()">Send</button>
	</div>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="ErrorMessage" *ngIf="ErrorMessage" class="alert alert-danger">{{ ErrorMessage }}</div>
</div>
